<template>

</template>

<script>
  import 'jquery-validation';

  export default {
    name: 'RegisterResearchLine',
    mounted() {
      /**
       * Show select2 options
       */
      const $search = $('.search-select-users')
      $search.select2({
        ajax: {
          url: '/api/v1/users',
          dataType: 'json',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data(params) {
            return {
              q: params.term,
              page: params.page || 1,
            }
          },
          processResults(data, params) {
            params.page = params.page || 1

            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })

      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function(element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function(label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            key: {
              required: true,
              maxlength: 255,
            },
            title: {
              required: true,
              maxlength: 255,
            },
            primary_workplace_id: {
              required: true,
            },
          },
          messages: {
            key: {
              required: 'Este campo es requerido.',
              maxlength: 'El texto no debe superar los 255 caracteres.',
            },
            title: {
              required: 'Este campo es requerido.',
              maxlength: 'El texto no debe superar los 255 caracteres.',
            },
            primary_workplace_id: {
              required: 'Seleccione el centro principal',
            },
          },
          submitHandler(form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
      })
    },
  }
</script>
